import * as R from 'ramda';
import { Form, message } from 'antd';
import { connect } from 'react-redux';
import { withProps, withHandlers } from 'recompose';

import { closeCurrentModal } from '..';
import { getResErrorMsg } from '../../utils';
import CompanyForm from '../../components/company-form';
import { handleCompanyCreate } from '../../redux/thunk/companies';
import { createCompanyFailure } from '../../redux/actions/companies';


const mapStateToProps = ({ companies: { isCreating } }) => ({
  isLoading: isCreating,
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeCurrentModal()),
  handleCompanyCreate: data => dispatch(handleCompanyCreate(data)),
  failedToCreateCompanyAction: () => dispatch(createCompanyFailure()),
});

export const AddNewCompanyModal = Form.create()(R.compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps({ title: 'Add Company' }),
  withHandlers({
    onSubmitForm: ({
      form,
      ...actions
    }) => (event) => {
      event.preventDefault();
      form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          actions.handleCompanyCreate(values)
            .then(() => {
              actions.closeModal();
              message.success('Company successfully added');
            })
            .catch((error) => {
              actions.failedToCreateCompanyAction();
              message.error(`${getResErrorMsg(error)}`);
            });
        } else {
          console.error(err);
        }
      });
    },
  }),
)(CompanyForm));



// WEBPACK FOOTER //
// ./src/modals/add-new-company/index.js